import { render, staticRenderFns } from "./addgoodssalereturnpay.vue?vue&type=template&id=48c1bdda&scoped=true&"
import script from "./addgoodssalereturnpay.vue?vue&type=script&lang=js&"
export * from "./addgoodssalereturnpay.vue?vue&type=script&lang=js&"
import style0 from "./addgoodssalereturnpay.vue?vue&type=style&index=0&id=48c1bdda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c1bdda",
  null
  
)

export default component.exports